import React, { FC } from "react";
import clsx from "clsx";

import MapActionButtons from "../../../organisms/Career/MapActionButtons";
import commonStyles from "../CareerReference.module.scss";

import styles from "./Summary.module.scss";

type Props = {
  createCareerSheets: () => void;
};

const Summary: FC<Props> = ({ createCareerSheets }) => {
  return (
    <div className={styles.wrapper}>
      <p className={clsx(commonStyles.title, styles.title)}>
        未来の選択肢は、
        <br className={commonStyles.isSp} />
        自分で広げるもの。
      </p>
      <p className={clsx(commonStyles.text, styles.text)}>
        未来は決められたものを選ぶのではなく、
        <br />
        自分の「強み」と「社会の変化」を
        <br className={commonStyles.isSp} />
        掛け合わせてつくるもの。
        <br />
        キャリア開拓モードを使えば、
        <br className={commonStyles.isSp} />
        そのヒントが見つかる。
        <br />
        <br />
        「自分が何を大切にする人間か」を知れば、
        <br />
        どんな時代でも自分らしい選択ができる。
        <br />
        さあ、一緒に未来を開拓しよう！
      </p>
      <div className={styles.actionButtons}>
        <MapActionButtons createCareerSheets={createCareerSheets} />
      </div>
    </div>
  );
};

export default Summary;
